import {Geolocation, PermissionStatus} from '@capacitor/geolocation';
import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {environment} from 'src/app/environments/environment';

interface UserLocationState {
  latitude: number | undefined;
  longitude: number | undefined;
  accuracy: number | undefined;
}

const initialState: UserLocationState = {
  latitude: undefined,
  longitude: undefined,
  accuracy: undefined
};

export const UserLocationStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    async init() {
      if (['web', ''].includes(environment.platform)) return;

      let permissionStatus = await Geolocation.checkPermissions();
      if (shouldRequestPermissions(permissionStatus)) {
        permissionStatus = await Geolocation.requestPermissions();
      }

      if (!didGrantPermission(permissionStatus)) return;

      try {
        const position = await Geolocation.getCurrentPosition();
        if (position) {
          patchState(store, {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy
          });
        }
      } catch (error) {
        console.log("Unable to obtain current position", error);
      }

      try {
        await Geolocation.watchPosition({}, position => {
          if (position) {
            patchState(store, {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              accuracy: position.coords.accuracy
            });
          }
        });
      } catch (error) {
        console.log("Unable to watch position", error);
      }
    }
  })
));

const shouldRequestPermissions = (permissionStatus: PermissionStatus) => {
  return permissionStatus.coarseLocation === 'prompt' ||
    permissionStatus.location === 'prompt';
}

const didGrantPermission = (permissionStatus: PermissionStatus) => {
  return permissionStatus.coarseLocation === 'granted' || permissionStatus.location === 'granted';
}
